import { render, staticRenderFns } from "./relationFormat.vue?vue&type=template&id=617db25e"
import script from "./relationFormat.vue?vue&type=script&lang=js"
export * from "./relationFormat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports